/**
 * /pwa 等 quietShell 路由：尽早关掉全站营销/登录前弹窗，避免导航过程中闪一下。
 * 须在 Pinia install 之后调用（router.beforeEach / App watch）。
 */
import { useRegisterRewardStore } from '@/stores/registerReward.js';
import { useTrialFundStore } from '@/stores/trialFund.js';
import { useDepositBonusPromptStore } from '@/stores/depositBonusPrompt.js';

export function silenceQuietShellPrompts() {
  try {
    useRegisterRewardStore().resetGuestPrompt();
    const trial = useTrialFundStore();
    trial.dismissGuestPrompt();
    trial.closeGuestPrompt();
    useDepositBonusPromptStore().hideForQuietShell();
  } catch {
    /* Pinia 未就绪或 store 暂不可用时忽略 */
  }
}
